import React from 'react';
import './App.css';
import Routing from './components/Routing';
import { PublicPasswordProvider } from './context/PublicPasswordProvider';


function App() {
    return (
        <div>
            <PublicPasswordProvider>
                <Routing />
            </PublicPasswordProvider>
        </div>
    );
}

export default App;
